import { addCustomEventListener } from "../../utils/event-listener";
import { isMessageViewed, registerMessageViewed } from "../../utils/session-storage-manager";
import { toasterTemplate } from "./toaster-template";
import * as liteComponents from "../../komodo-assets/lite-components";
var KOMODO_TOASTER_CLOSED_EVENT = "removed.komodo.notification";
/**
 * This function creates a toaster element with the given options
 * @param {*} options
 * @param {*} generateKomodoToasterInstance
 * @returns void
 */ export var createToaster = function(options, generateKomodoToasterInstance) {
    if (document.getElementById(options.componentId)) {
        console.error("Toaster with id [".concat(options.componentId, "] already exists"));
        return;
    }
    var closeIconFunction = function() {
        dispatchCloseToasterEvent(komodoToasterInstance.element_);
    };
    var toaster = toasterTemplate(options, closeIconFunction);
    toaster.classList.add('ca-custom-toaster');
    var komodoToasterInstance = generateKomodoToasterInstance(toaster.children[0]);
    addCustomEventListener(komodoToasterInstance.element_, KOMODO_TOASTER_CLOSED_EVENT, function() {
        return console.log("Toaster closed");
    }, function() {
        var _options_timesDisplayedPerSession;
        return registerMessageViewed(options.componentId, (_options_timesDisplayedPerSession = options.timesDisplayedPerSession) !== null && _options_timesDisplayedPerSession !== void 0 ? _options_timesDisplayedPerSession : 1, options.supportSession);
    }, function() {
        return toaster.remove();
    });
    if (options.timeout) {
        setTimeout(function() {
            dispatchCloseToasterEvent(komodoToasterInstance.element_);
        }, options.timeout);
    }
    var _options_timesDisplayedPerSession;
    if (!isMessageViewed(options.componentId, (_options_timesDisplayedPerSession = options.timesDisplayedPerSession) !== null && _options_timesDisplayedPerSession !== void 0 ? _options_timesDisplayedPerSession : 1, options.supportSession)) {
        document.body.appendChild(toaster);
    }
};
/**
 * Dispatches the KOMODO_TOOLTIP_CLOSED_EVENT to the tooltip element
 * @param {HTMLElement} toaster
 */ var dispatchCloseToasterEvent = function(toaster) {
    var customEvent = liteComponents.componentHandler.createEvent(KOMODO_TOASTER_CLOSED_EVENT, null, !1, !0);
    toaster.dispatchEvent(customEvent);
};
